import { Box, Button, Card, Grid, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import CalenderIcon from "../../../assets/Icon/CalenderIcon";
import { LocationOn } from "@mui/icons-material";
import { ReservationStatus } from "../../../pages/reservationFlow/reservationDetails";
import {
  convertUtcToYard,
  getTimeZone,
  getMonthlyToDate,
} from "../../../utils/momentUtils";
import { useTranslation } from "react-i18next";
import { MOMENT_CONSTANTS } from "../../../utils/momentUtils";
import { useMemo } from "react";
import storePersist, { localConstant } from "../../../services/localStorage";
import ErrorIcon from "../../../assets/Icon/ErroIcon";
import { isMobileDeviceCheck } from "../../../utils";

const PastReservationCard = (props) => {
  const { t } = useTranslation();

  const {
    total_spots,
    reservation_id,
    location_city,
    reservation_from_date,
    reservation_to_date,
    reservation_status,
    timezone,
    location_id,
    spot_number_list = [],
    payment_status_code,
  } = props?.data;

  const currentUserType = storePersist.get(localConstant.USER_PROFILE);

  const from_date = convertUtcToYard({
    date: reservation_from_date,
    enableFormat: true,
    timeZone: timezone,
    dateFormat: reservation_to_date
      ? undefined
      : MOMENT_CONSTANTS.date.fullMonthDay,
  });
  const to_date = reservation_to_date
    ? convertUtcToYard({
        date: reservation_to_date,
        enableFormat: true,
        timeZone: timezone,
      })
    : getMonthlyToDate({ date: reservation_from_date, timeZone: timezone });

  const formatedtedDate = reservation_to_date
    ? `${from_date} to ${to_date} ${getTimeZone(timezone)}`
    : `${from_date} ${getTimeZone(timezone)}`;

  const total_spots_available =
    total_spots > 1
      ? `${total_spots} ${t("pages.reservation.text02")} `
      : `${total_spots} spot reserved`;

  const getSpotOrder = useMemo(() => {
    if (spot_number_list.length <= 0) return [""];
    if (spot_number_list.length === 1) return [spot_number_list[0]];
    spot_number_list.sort((a, b) => a - b);
    let segregatedSpots = [];
    let currentSpot = {
      spot: spot_number_list[0],
      spotIdx: 0,
    };
    let i;
    for (i = 1; i < spot_number_list.length; i++) {
      if (spot_number_list[i - 1] === spot_number_list[i] - 1) continue;
      else {
        if (currentSpot.spotIdx === i - 1)
          segregatedSpots.push(spot_number_list[i - 1]);
        else {
          if (currentSpot.spot === spot_number_list[i - 1])
            segregatedSpots.push(spot_number_list[i - 1]);
          else
            segregatedSpots.push(
              `${currentSpot.spot}-${spot_number_list[i - 1]}`,
            );
        }
        currentSpot = {
          spot: spot_number_list[i],
          potIdx: i,
        };
      }
    }
    if (i === spot_number_list.length)
      if (currentSpot.spot === spot_number_list[i - 1])
        segregatedSpots.push(spot_number_list[i - 1]);
      else
        segregatedSpots.push(
          `${currentSpot.spot}-${spot_number_list[spot_number_list.length - 1]}`,
        );
    return segregatedSpots;
  }, [spot_number_list]);

  const gates =
    props?.gateList?.length > 0 &&
    props?.gateList.filter((d) => d.location_id === location_id);

  return (
    <Card
      style={{ cursor: "pointer" }}
      sx={{ p: 1, width: 1, maxWidth: 430, mb: 1 }}
      onClick={() => {
        props?.onPress();
      }}
    >
      <Stack
        alignItems="center"
        justifyContent={"space-between"}
        direction="row"
        spacing={0}
      >
        <Typography variant="subtitle2" color={"#3A4454"}>
          {`${t("components.pastReservationCard.text01")} ${reservation_id} - ${
            location_city || ""
          }`}
        </Typography>
      </Stack>

      <Grid display="flex" justifyContent="space-between">
        <Stack
          alignItems="center"
          justifyContent={"space-between"}
          direction="row"
          spacing={0}
        >
          <Typography variant="subtitle2" color={"#A19F9D"}>
            {total_spots_available}
            <Typography
              variant="subtitle2"
              color={"black"}
              style={{ fontWeight: "bold" }}
            >
              {getSpotOrder && getSpotOrder.length > 10
                ? `Spot(s):${getSpotOrder.splice(0, 10).join(", ")} ...`
                : `Spot(s):${getSpotOrder?.join(", ")}`}
            </Typography>
            <ReservationStatus statusCode={reservation_status} />
          </Typography>
        </Stack>
        <Grid>
          {payment_status_code === "PENDING_PAYMENT" &&
          currentUserType === "OWNER" &&
          isMobileDeviceCheck() ? (
            <Box
              width={"35%"}
              style={{
                width: 98,
                height: 32,
                alignItems: "center",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <ErrorIcon alignSelf="center" />
              <Typography
                variant="fontSize12"
                color={"red"}
                marginTop={"-5px"}
                textAlign={"center"}
              >
                {`${t("components.upcomingCard.text05")}`}
              </Typography>
              <Button
                onClick={(e) => {
                  e.stopPropagation();
                  props?.onPressPayNow(gates);
                }}
                variant=""
                alignSelf={"center"}
                style={{
                  width: "100%",
                  height: 28,
                  alignItems: "center",
                  display: "flex",
                  backgroundColor: "#f2dcdc",
                }}
              >
                <Typography
                  variant="buttonText"
                  color="red"
                  style={{ fontWeight: "bold", fontSize: "12px" }}
                >
                  {t("commonLabels.text26")}
                </Typography>
              </Button>
            </Box>
          ) : (
            <></>
          )}
        </Grid>
      </Grid>

      <Stack alignItems="center" direction="row" spacing={0}>
        <CalenderIcon />
        <Typography sx={{ marginLeft: "5px" }} variant="fontSize12">
          {formatedtedDate}
        </Typography>
      </Stack>

      <Stack alignItems="center" direction="row" spacing={0}>
        <LocationOn
          color="#908E8D"
          style={{ fill: "#908E8D", height: "18px", width: "18px" }}
        />
        <Typography variant="subtitle2" sx={{ marginLeft: "5px" }}>
          {props?.data?.location_address_line_1}
        </Typography>
      </Stack>
    </Card>
  );
};

export default PastReservationCard;
